export const TASK_STATUS = {
    NOT_STARTED: {
        value: 'NotStarted',
        label: 'Not Started'
    },
    IN_PROGRESS: {
        value: 'InProgress',
        label: 'In Progress'
    },
    SUCCESSFULLY_COMPLETED: {
        value: 'SuccessfullyCompleted',
        label: 'Completed'
    },
    COMPLETED_WITH_WARNINGS: {
        value: 'CompletedWithWarnings',
        label: 'Warnings'
    },
    SCHEDULED: {
        value: 'Scheduled',
        label: 'Scheduled'
    },
    ERROR: {
        value: 'Error',
        label: 'Error'
    }
};

export const STAGE = {
    STAGE_ONE: {
        displayName: 'Pre-engagement',
        apiStageName: 'StageOne'
    },
    STAGE_TWO: {
        displayName: 'Data Collection',
        apiStageName: 'CompanyStage'
    },
    STAGE_THREE: {
        displayName: 'File Collection',
        apiStageName: 'FileCollectionStage'
    },
    STAGE_FOUR: {
        displayName: 'Employee Mapping',
        apiStageName: 'EmployeeMappingStage'
    },
    STAGE_FIVE: {
        displayName: 'Data Import',
        apiStageName: 'DataImport'
    }
};


export const SALARY_PRORATIONMETHODS = [
  {
    value: 0,
    label: 'Do not prorate',
    description: 'No proration is applied.'
  },
  {
    value: 1,
    label: 'Daily Difference (Working Days)',
    description: 'Calculates the salary difference per day based on working days within the period.'
  },
  {
    value: 2,
    label: 'Daily Difference (Calendar Days)',
    description: 'Calculates the salary difference per day based on calendar days within the period.'
  },
  {
    value: 3,
    label: 'Daily Difference (365 Days)',
    description: 'Calculates the salary difference using a fixed 365-day year.'
  },
  {
    value: 4,
    label: 'Working Days at Each Salary',
    description: 'Splits the period into working days at each salary level and calculates accordingly.'
  },
  {
    value: 5,
    label: 'Calendar Days at Each Salary',
    description: 'Splits the period into calendar days at each salary level and calculates accordingly.'
  }
];

export const REDUCEDPERIOD_PRORATIONMETHODS = [
  {    value: 0,
    label: 'Do not prorate',
    description: 'No proration is applied.'
  },
  {    value: 1,
    label: 'Annual Salary / 365 Days',
    description: 'Calculates proration by dividing the annual salary by 365 days, using a fixed daily rate regardless of leap years.'
  },
  {
    value: 2,
    label: 'Annual Salary / Calendar Days in Period',
    description: 'Calculates proration by dividing the annual salary by the actual number of calendar days in the selected period (e.g. 28–31 days).'
  },
  {
    value: 3,
    label: 'Annual Salary / Working Days in Period',
    description: 'Calculates proration by dividing the annual salary by the number of working days in the selected period, based on the employee’s working pattern.'
  }
];


export const CUSTOMER_INDUSTRIES = [
{ value: 'Accounting', label: 'Accounting' },
{ value: 'Advertising', label: 'Advertising' },
{ value: 'Agriculture and Non-petrol Natural Resource Extraction', label: 'Agriculture and Non-petrol Natural Resource Extraction' },
{ value: 'Airline', label: 'Airline' },
{ value: 'Architects', label: 'Architects' },
{ value: 'Baker', label: 'Baker' },
{ value: 'Bank', label: 'Bank' },
{ value: 'Bookeepers', label: 'Bookeepers' },
{ value: 'Brewery', label: 'Brewery' },
{ value: 'Broadcasting Printing and Publishing', label: 'Broadcasting Printing and Publishing' },
{ value: 'Brokers', label: 'Brokers' },
{ value: 'Building Industry', label: 'Building Industry' },
{ value: 'Building Society', label: 'Building Society' },
{ value: 'Building Supply Retail', label: 'Building Supply Retail' },
{ value: 'Bureau', label: 'Bureau' },
{ value: 'Business Services', label: 'Business Services' },
{ value: 'Catering', label: 'Catering' },
{ value: 'Charity', label: 'Charity' },
{ value: 'Chemical', label: 'Chemical' },
{ value: 'Cleaning', label: 'Cleaning' },
{ value: 'Clothing', label: 'Clothing' },
{ value: 'Club', label: 'Club' },
{ value: 'College', label: 'College' },
{ value: 'Computer', label: 'Computer' },
{ value: 'Construction', label: 'Construction' },
{ value: 'Consultant', label: 'Consultant' },
{ value: 'Consulting', label: 'Consulting' },
{ value: 'Consumer Services', label: 'Consumer Services' },
{ value: 'Courier', label: 'Courier' },
{ value: 'Dentist', label: 'Dentist' },
{ value: 'Design', label: 'Design' },
{ value: 'Design, Direction and Creative Management', label: 'Design, Direction and Creative Management' },
{ value: 'Distribution', label: 'Distribution' },
{ value: 'Distributors, Dispatchers and Processors', label: 'Distributors, Dispatchers and Processors' },
{ value: 'Doctor', label: 'Doctor' },
{ value: "Doctor's Offices and Clinics", label: "Doctor's Offices and Clinics" },
{ value: 'Durable Manufacturing', label: 'Durable Manufacturing' },
{ value: 'Eating and Drinking Places', label: 'Eating and Drinking Places' },
{ value: 'Education', label: 'Education' },
{ value: 'Electrical', label: 'Electrical' },
{ value: 'Electronic', label: 'Electronic' },
{ value: 'Engineering', label: 'Engineering' },
{ value: 'Entertainment', label: 'Entertainment' },
{ value: 'Entertainment Retail', label: 'Entertainment Retail' },
{ value: 'Equipment Rental and Leasing', label: 'Equipment Rental and Leasing' },
{ value: 'Farming', label: 'Farming' },
{ value: 'Financial', label: 'Financial' },
{ value: 'Financial Services', label: 'Financial Services' },
{ value: 'Food and Drink', label: 'Food and Drink' },
{ value: 'Food and Tobacco Processing', label: 'Food and Tobacco Processing' },
{ value: 'Government Department', label: 'Government Department' },
{ value: 'Hair', label: 'Hair' },
{ value: 'Health', label: 'Health' },
{ value: 'Higher Education', label: 'Higher Education' },
{ value: 'Hospital', label: 'Hospital' },
{ value: 'Hoteliers', label: 'Hoteliers' },
{ value: 'Housing Association', label: 'Housing Association' },
{ value: 'I.T.', label: 'I.T.' },
{ value: 'Inbound Capital Intensive Processing', label: 'Inbound Capital Intensive Processing' },
{ value: 'Inbound Repair and Services', label: 'Inbound Repair and Services' },
{ value: 'Insurance', label: 'Insurance' },
{ value: 'Lawyers', label: 'Lawyers' },
{ value: 'Legal Services', label: 'Legal Services' },
{ value: 'Leisure', label: 'Leisure' },
{ value: 'Local Authority', label: 'Local Authority' },
{ value: 'Logistics', label: 'Logistics' },
{ value: 'Manufacturing', label: 'Manufacturing' },
{ value: 'Marketing', label: 'Marketing' },
{ value: 'Media', label: 'Media' },
{ value: 'Mining', label: 'Mining' },
{ value: 'Motor Trade', label: 'Motor Trade' },
{ value: 'Music', label: 'Music' },
{ value: 'News Paper', label: 'News Paper' },
{ value: 'Non-Durable Merchandise Retail', label: 'Non-Durable Merchandise Retail' },
{ value: 'Nursery', label: 'Nursery' },
{ value: 'Nursing Home', label: 'Nursing Home' },
{ value: 'Oil Exp.', label: 'Oil Exp.' },
{ value: 'Other', label: 'Other' },
{ value: 'Outbound Consumer Service', label: 'Outbound Consumer Service' },
{ value: 'Packaging', label: 'Packaging' },
{ value: 'Painter and Decorator', label: 'Painter and Decorator' },
{ value: 'Payroll', label: 'Payroll' },
{ value: 'Pensions', label: 'Pensions' },
{ value: 'Personal', label: 'Personal' },
{ value: 'Petrochemical Extraction and Distribution', label: 'Petrochemical Extraction and Distribution' },
{ value: 'Petroleum', label: 'Petroleum' },
{ value: 'Pharmaceutical', label: 'Pharmaceutical' },
{ value: 'Pharmacy', label: 'Pharmacy' },
{ value: 'Plumber', label: 'Plumber' },
{ value: 'Police', label: 'Police' },
{ value: 'Post Office', label: 'Post Office' },
{ value: 'Printers', label: 'Printers' },
{ value: 'Property', label: 'Property' },
{ value: 'Public House', label: 'Public House' },
{ value: 'Public Sector', label: 'Public Sector' },
{ value: 'Publisher', label: 'Publisher' },
{ value: 'Qtac Dealer', label: 'Qtac Dealer' },
{ value: 'Recruitment', label: 'Recruitment' },
{ value: 'Restaurant', label: 'Restaurant' },
{ value: 'Retailer', label: 'Retailer' },
{ value: 'Sales', label: 'Sales' },
{ value: 'School', label: 'School' },
{ value: 'Security', label: 'Security' },
{ value: 'Service', label: 'Service' },
{ value: 'Service Retail', label: 'Service Retail' },
{ value: 'Shipping', label: 'Shipping' },
{ value: 'SIG Affiliations', label: 'SIG Affiliations' },
{ value: 'Social Services', label: 'Social Services' },
{ value: 'Software', label: 'Software' },
{ value: 'Solicitor', label: 'Solicitor' },
{ value: 'Special Outbound Trade Contractors', label: 'Special Outbound Trade Contractors' },
{ value: 'Specialty Realty', label: 'Specialty Realty' },
{ value: 'Sports Club', label: 'Sports Club' },
{ value: 'Stock Broker', label: 'Stock Broker' },
{ value: 'Tax Advisor', label: 'Tax Advisor' },
{ value: 'Taxi', label: 'Taxi' },
{ value: 'Telecoms', label: 'Telecoms' },
{ value: 'Television', label: 'Television' },
{ value: 'Textiles', label: 'Textiles' },
{ value: 'Timber', label: 'Timber' },
{ value: 'Training', label: 'Training' },
{ value: 'Transport', label: 'Transport' },
{ value: 'Transportation', label: 'Transportation' },
{ value: 'Travel', label: 'Travel' },
{ value: 'Umbrella Company', label: 'Umbrella Company' },
{ value: 'University', label: 'University' },
{ value: 'Utility Creation and Distribution', label: 'Utility Creation and Distribution' },
{ value: 'Vehicle Retail', label: 'Vehicle Retail' },
{ value: 'Vet', label: 'Vet' },
{ value: 'Waste', label: 'Waste' },
{ value: 'Water Company', label: 'Water Company' },
{ value: 'Wholesale', label: 'Wholesale' },
{ value: 'Wholesaler', label: 'Wholesaler' }
];